var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriteltning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.075,11.845,10.241,6.938a.263.263,0,0,0-.456,0L6.952,11.845a.263.263,0,0,0,.228.395H8.356A.474.474,0,0,0,8.766,12l1.019-1.766a.263.263,0,0,1,.456,0l1.022,1.769a.466.466,0,0,0,.4.233h1.179A.264.264,0,0,0,13.075,11.845Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.773,9.117S6.111,6.236,6.092,6.205a.059.059,0,0,1,.047-.091h.655A.213.213,0,0,0,6.979,5.8L5.038,2.434a.213.213,0,0,0-.369,0L2.729,5.8a.213.213,0,0,0,.185.319H3.57a.061.061,0,0,1,.051.083L1.935,9.117a.213.213,0,0,0,.184.32H4.246a.205.205,0,0,1,.2.205v2.226a.4.4,0,0,0,.806,0V9.65a.213.213,0,0,1,.213-.213H7.588A.214.214,0,0,0,7.773,9.117Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriteltning);
export default __webpack_public_path__ + "static/media/FRI TELTNING.0b1a3a3dc1d8c78e876b9203fa244481.svg";
export { ForwardRef as ReactComponent };